/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'company-hub.search-extension.custom-search-config-panel.corner-style-label': '角',
  'company-hub.search-extension.custom-search-config-panel.default-placeholder-text':
    '検証済みのお知らせ、リソース、ポリシーを検索',
  'company-hub.search-extension.custom-search-config-panel.filters-title': 'フィルター',
  'company-hub.search-extension.custom-search-config-panel.placeholder-text-label': 'プレースホルダー テキスト',
  'company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label':
    '読者に表示されるプロンプトをカスタマイズします',
  'company-hub.search-extension.custom-search-config-panel.preamble': 'フィルター済み検索バーを追加します',
  'company-hub.search-extension.custom-search-config-panel.round-corner-style-label': '角丸',
  'company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label': 'スクエア',
  'company-hub.search-extension.custom-search-config-panel.styles-fill-color-label': '塗りつぶしの色',
  'company-hub.search-extension.custom-search-config-panel.styles-text-color-label': 'テキストの色',
  'company-hub.search-extension.custom-search-config-panel.styles-title': 'スタイル',
  'company-hub.search-extension.custom-search-config-panel.title': 'カスタム検索',
  'company-hub.search-extension.manifest.default-placeholder-text': '検証済みのお知らせ、リソース、ポリシーを検索',
  'company-hub.search-extension.manifest.macro-description': 'フィルター済み検索バーを追加します',
  'company-hub.search-extension.manifest.macro-title': 'カスタム検索',
  'company-hub.search-extension.more-button': 'その他の結果を表示',
};
